import { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import styled from 'styled-components'

import { PARAM_SORT_KEYS } from '../../constants'
import type { PARAM_SORT_TYPE } from '../../constants'

import { onParams, toast } from '../../utils'

import { StoresContext } from '../../provider/StoreProvider'

import { Sort } from '../../components/paramOption'
import { PagingContent } from '../../components/pagingList'
import { ProductCard } from './components/ProductCard'

const sortList: { type: PARAM_SORT_TYPE; title: string }[] = [
  {
    type: PARAM_SORT_KEYS.LATEST,
    title: '최근 거래순',
  },
  {
    type: PARAM_SORT_KEYS.OLDEST,
    title: '과거 거래순',
  },
]

export const AssetFinish = observer(() => {
  const { myStore } = useContext(StoresContext)
  const pagingStore = myStore.assetFinishPagingStore

  const [categoryIds] = useState<number>(0)
  const [sortType, setSortType] = useState<PARAM_SORT_TYPE>(PARAM_SORT_KEYS.LATEST)

  useEffect(() => {
    try {
      loadData()
    } catch (err: unknown) {
      toast('페이지를 불러오는데 실패했습니다.', err)
    }
  }, [])

  useEffect(() => {
    try {
      onParams({
        categoryIds,
        sortType,
        store: pagingStore,
      })
    } catch (err: unknown) {
      toast('데이터를 불러오는데 실패했습니다.', err)
    }
  }, [sortType, categoryIds])

  const loadData = async () => {
    await pagingStore.load(undefined, true)
  }

  return (
    <>
      <SortContainer>
        <Sort sortType={sortType} sortList={sortList} setSortType={setSortType} />
      </SortContainer>
      {/* TODO: PagingContent로 변경 */}
      <PagingContent pagingStore={pagingStore}>
        <ProductsContainer>
          {pagingStore.list.map((product) => (
            <ProductCard key={product.id} {...product} />
          ))}
        </ProductsContainer>
      </PagingContent>
    </>
  )
})

const ProductsContainer = styled.article`
  display: grid;
  grid-template-columns: repeat(2, minmax(160px, 100%));
  gap: 24px 15px;
  padding: 0 16px;
`

const SortContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px;
`
